import $ from "jquery";

class Vaga {
  constructor(loading) {
    this.loading = loading;
    if (document.querySelector("#demostrar-interesse")) {
      this.demostrar_interesse = document.querySelector("#demostrar-interesse");
    }
   
    if (document.querySelector("#concorrer")) {
      this.concorrer = document.querySelector("#concorrer");
    }
    this.events();
  }

  events() {
    if (document.querySelector("#add-vaga")) {
      let add_vaga = document.querySelector("#add-vaga");

      add_vaga.addEventListener("click", this.saveNewVacancy.bind(this));
    }

    if (this.demostrar_interesse) {
      this.demostrar_interesse.addEventListener(
        "click",
        this.showInterest.bind(this)
      );
    }
    
    if (this.concorrer) {
      this.concorrer.addEventListener(
        "click",
        this.applyToVacancy.bind(this)
      );
    }

    if (document.querySelector("#search-vaga")) {
      let search_vaga = document.querySelector("#search-vaga");
      search_vaga.addEventListener("keyup", this.searchVaga.bind(this));
    }

    if (document.querySelector("#visualizar-vaga")) {
      let visualizar_vaga = document.querySelector("#visualizar-vaga");

      $(visualizar_vaga).on("click", ".visualizar", (e) =>
        this.visualizarVaga.bind(this)(e)
      );
    }

    if (document.querySelector("#vagas-list")) {
      $("#vagas-list").on("click", ".delete-vaga", (e) =>
        this.deletarVaga.bind(this)(e)
      );
    }

    $("#vagas-propostas").on("click", ".interessado", (e) =>
        this.interessado.bind(this)(e)
    );

    $("#vagas-propostas").on("click", ".nao-interessado", (e) =>
        this.naoInteressado.bind(this)(e)
    );
  }



  interessado(e){

    let candidato =$(e.target).data('userid');
    let vagaId= $(e.target).data('postid');

    this.loading.showLoadingAnimation();

    $.ajax({
      type: "GET",
      url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaId,
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
        this.loading.hideLoadingAnimation();

        let data = {
          acf: {},
        };


          let candidatos_interessados = response.acf.candidatos_interessados;

          if (candidatos_interessados) {
            candidatos_interessados.push(candidato);
            data.acf.candidatos_interessados = candidatos_interessados;
          } else {
            data.acf.candidatos_interessados = [candidato];
          }

        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaId,
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            Swal.fire("Salvo!", "Interesse demostrado com sucesso.", "success");
            
            console.log(response)

            // $(e.target).addClass("d-none");
          },
          error: (error) => {
            Swal.fire("Error!", "Ocorreu um durante tente de novo!", "error");
          },
        });
      },
      error: (response) => {
        this.loading.hideLoadingAnimation();
      },
    });
  }

  naoInteressado(e){

    let candidato =$(e.target).data('userid');
    let vagaId= $(e.target).data('postid');

    this.loading.showLoadingAnimation();
    $.ajax({
      type: "GET",
      url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaId,
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
        this.loading.hideLoadingAnimation();

        let data = {
          acf: {},
        };


          let candidatos_nao_interessados = response.acf.candidatos_nao_interessados;

          if (candidatos_nao_interessados) {
            candidatos_nao_interessados.push(candidato);
            data.acf.candidatos_nao_interessados = candidatos_nao_interessados;
          } else {
            data.acf.candidatos_nao_interessados = [candidato];
          }

        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaId,
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            Swal.fire("Salvo!", "Estado actualizado com sucesso.", "success");
            

            // $(e.target).addClass("d-none");
          },
          error: (error) => {
            Swal.fire("Error!", "Ocorreu um durante tente de novo!", "error");
          },
        });
      },
      error: (response) => {
        this.loading.hideLoadingAnimation();
      },
    });
  }



  deletarVaga(e) {
    Swal.fire({
      title: "Confirmar",
      text: "Tens certeza que pretendes eliminar esta vaga?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        let postID = $(e.target).data("id");

        this.loading.showLoadingAnimation();
        $.ajax({
          type: "DELETE",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + postID,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            this.loading.hideLoadingAnimation();
            $(e.target).parent().parent().remove();
            Swal.fire(
              "Eliminado!",
              "Vaga eliminada com sucesso.",
              "success"
            );
          },
          error: (error) => {
            this.loading.hideLoadingAnimation();
            console.log(error);
            Swal.fire("Error!", "Ocorreu um error inesperado!", "error");
          },
        });
      }
    });
  }

  visualizarVaga(e) {
    let postID = $(e.target).data("empresa");
    let vagaId = $(e.target).data("vaga");
    let candidato = $(e.target).data("candidato");

    this.loading.showLoadingAnimation();
    $.ajax({
      type: "GET",
      url: maisempregoData.root_url + "/wp-json/wp/v2/empresa/" + postID,
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
        let empresa = response;

        this.loading.hideLoadingAnimation();
        let nome_da_empresa = response.acf.nome_da_empresa;
        let posicao = $("#vaga-posicao-" + vagaId).text();
        let descricao = $("#vaga-descricao-" + vagaId).text();

        Swal.fire({
          html: `
                  <div >
                      <div class="form-group ">
                          <label for="">Empresa</label>
                          <input type="text" readonly value="${nome_da_empresa}"   />
                      </div>

                      <div class="form-group ">
                          <label for="">Posição</label>
                          <input type="text" readonly  value="${posicao}" />
                      </div>

                      <div class="form-group ">
                          <label for="">Província</label>
                          <input type="text" name="provincia" value="${(response.acf.provincia)? response.acf.provincia : ''}"  />
                      </div>

                    <div class="form-group ">
                        <label for="">Distrito</label>
                        <input type="text" name="distrito"value="${(response.acf.distrito)? response.acf.distrito : ''}"    />
                    </div>
          
                      <div class="form-group ">
                          <label for="">Descrição</label>
                          <textarea readonly cols="30" rows="5" >${descricao}</textarea>
                      </div>
                  </div>
                  `,
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: " Interessado",
          denyButtonText: "Não interessado",
          cancelButtonText: "Cancelar",

          customClass: {
            content: "my-swal-content",
            popup: "my-swal-container",
            confirmButton: "confirm-swal-button",
            denyButton: "deny-swal-button",
            cancelButton: "cancel-swal-button",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Handle form submission success
            console.log("Confirmado");
            this.actualizarEstado(vagaId, candidato, 1, $(e.target));
          } else if (result.isDenied) {
            // Action to perform when the user clicks the cancel button
            console.log("Rejeitado!");

            this.actualizarEstado(vagaId, candidato, 0, $(e.target));
            // You can add your custom logic here
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Action to perform when the user clicks the cancel button
            console.log("Canceled!");
            // You can add your custom logic here
          }
        });
      },
      error: (response) => {
        this.loading.hideLoadingAnimation();
      },
    });
  }

  actualizarEstado(vagaId, candidato, estado, button) {
    this.loading.showLoadingAnimation();
    $.ajax({
      type: "GET",
      url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaId,
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
        this.loading.hideLoadingAnimation();

        let data = {
          acf: {},
        };


        if (estado) {
          let candidatos_interessados = response.acf.candidatos_interessados;

          if (candidatos_interessados) {
            candidatos_interessados.push(candidato);
            data.acf.candidatos_interessados = candidatos_interessados;
          } else {
            data.acf.candidatos_interessados = [candidato];
          }
        } else {
          let candidatos_nao_interessados =
            response.acf.candidatos_nao_interessados;
          if (candidatos_nao_interessados) {
            candidatos_nao_interessados.push(candidato);
            data.acf.candidatos_nao_interessados = candidatos_nao_interessados;
          } else {
            data.acf.candidatos_nao_interessados = [candidato];
          }
        }

        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaId,
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            Swal.fire("Salvo!", "Estado actualizado com sucesso.", "success");

            $(button).addClass("d-none");
          },
          error: (error) => {
            Swal.fire("Error!", "Ocorreu um durante tente de novo!", "error");
          },
        });
      },
      error: (response) => {
        this.loading.hideLoadingAnimation();
      },
    });
  }

  searchVaga() {
    let search = $("#search-vaga").val();
    let activo = $("#search-vaga").data("estado") == "pendente" ? "0" : 1;

    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/vaga/v1/search",
      method: "POST",
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      data: {
        search,
        activo,
      },
      success: (response) => {
        // console.log(response)

        $("#vagas-list").html(this.vagaHtml(response));
      },
      error: function (error) {
        console.log("Error creating user.");
        console.log(error);
      },
    });
  }

  vagaHtml(vagas) {
    let html = "";

    if (vagas.length) {
      vagas.map((vaga) => {
        $("#vagas-list").addClass("space-between");
        html += `
          <div class="vaga__card">

              <h4 class="vaga__card-title">${vaga.posicao}</h4>

              <div class="vaga__card-content">

                  <strong>Descrição:</strong>

                  <p>${vaga.descricao ? vaga.descricao : ""}</p>
              </div>

              <div class="vaga__card-actions">
                 <i data-id="${
                    vaga.postId
                  }" class="fa-solid fa-trash-can text-outline-red delete-vaga"></i>
              </div>

          </div>
    
        `;
      });
    } else {
      $("#vagas-list").removeClass("space-between");
      html += `
        <div class="centered h-25 w-100"  >
            <h2 class="text-secondary">Nenhum vaga foi encontrada!</h2>
        </div>
      `;
    }

    return html;
  }

  saveNewVacancy() {


    Swal.fire({
      title: "Cadastrar vagas",

      html: `
            <form id="vaga-form">
                <div class="form-group ">
                    <label for="">Função</label>
                    <input type="text" name="posicao" id="posicao" required  placeholder="Digita a posição da vaga" />
                </div>

                <!--
                <div class="form-group ">
                    <label for="">Província</label>
                    <input type="text" name="provincia" id="provincia" required  placeholder="Digita a província" />
                </div>
                -->

                <div class="form-group ">
                  <label for="">Província</label>
                  <select class="input-small" name="provincia" id="provincia">
                    <option value="">Selecione a província</option>
                    <option value="Maputo (cidade)">Maputo
                      (cidade)</option>
                    <option value="Maputo (província)">
                      Maputo (província)</option>
                    <option value="Gaza">Gaza</option>
                    <option value="Inhambane">Inhambane</option>
                    <option value="Sofala">Sofala</option>
                    <option value="Manica">Manica</option>
                    <option value="Tete">Tete</option>
                    <option value="Zambézia">Zambézia</option>
                    <option value="Nampula">Nampula</option>
                    <option value="Niassa">Niassa</option>
                    <option value="Cabo Delgado">Cabo Delgado
                    </option>
                  </select>
                </div>

                <div class="form-group ">
                    <label for="">Distrito</label>
                    <input type="text" name="distrito" id="distrito" required  placeholder="Digita o distríto" />
                </div>
    
                <div class="form-group ">
                    <label for="">Descrição (Requisítos da vaga)</label>
                    <textarea name="descricao" id="descricao" cols="30" rows="5" required ></textarea>
                </div>
            </form>
            `,
      showCancelButton: true,
      confirmButtonText: "Salvar",
      preConfirm: (response) => {
        const form = document.getElementById("vaga-form");
        if (!form.checkValidity()) {
          Swal.showValidationMessage("Preencha todos campos por favor!");
          return false;
        }

        // Retrieve form values
        let posicao = $("#posicao").val();
        let descricao = $("#descricao").val();
        let provincia = $("#provincia").val();
        let distrito = $("#distrito").val();
        let post_id = $("#post_id").val();

        // Prepare the AJAX request data
        let data = {
          title: posicao,
          status: "publish",
          acf: {
            posicao,
            descricao,
            provincia,
            distrito,
            empresa: post_id,
          },
        };

        // Make the AJAX request
        this.loading.showLoadingAnimation();
        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/",
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            this.loading.hideLoadingAnimation();
            console.log(response);
            let html = `
                <div class="vaga__card">

                    <h4 class="vaga__card-title">${posicao}</h4>

                    <div class="vaga__card-content">

                        <strong>Descrição:</strong>

                        <p>${descricao}</p>
                    </div>

                    <div class="vaga__card-actions">
                    <i data-id="${
                     response.id
                    }" class="fa-solid fa-trash-can text-outline-red delete-vaga"></i>
                    </div>

                </div>
          
              `;

            $("#vagas-list").append(html);

            Swal.fire("Salvo!", "Vaga registada com sucesso!.", "success");

            // console.log(response);
          },
          error: (error) => {
            this.loading.hideLoadingAnimation();
            // console.log(error);
            Swal.fire(
              "Error!",
              "An error occurred during the AJAX request.",
              "error"
            );
          },
        });

        // Prevent closing the SweetAlert dialog while AJAX request is in progress
        Swal.showLoading();

        // Prevent closing the dialog automatically
        return false;
      },

      customClass: {
        content: "my-swal-content",
        popup: "my-swal-container",
        confirmButton: "confirm-swal-button",
        cancelButton: "cancel-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle form submission success
        const { descricao, posicao } = result.value;
      }
    });
  }

  showInterest() {
    // let candidato_id = $(e.target).val();

    this.loading.showLoadingAnimation();
    $.ajax({
      type: "POST",
      url: maisempregoData.root_url + "/wp-json/maisemprego/empresa/v1/vagas",
      data: { empresa_id: $("#empresa_id").val() },
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
        // console.log(response)
        this.loading.hideLoadingAnimation();
        this.showVacancyList(response);
      },
      error: (response) => {
        this.loading.hideLoadingAnimation();
      },
    });
  }
  
  applyToVacancy() {
    let novoCandidato = $('#candidato_id').val();

    let vagaPostID = $('#concorrer').data('vaga')

    
    this.loading.showLoadingAnimation();
    $.ajax({
      type: "GET",
      url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" +vagaPostID,
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
        console.log(response.acf.candidaturas_expontaneas);

        let candidaturas = response.acf.candidaturas_expontaneas;



        if (candidaturas) {
          candidaturas.push(parseInt(novoCandidato));
        } else {
          candidaturas = [parseInt(novoCandidato)];
        }

        let data = {
          acf: {
            candidaturas_expontaneas: candidaturas,
          },
        };


        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vagaPostID,
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            this.loading.hideLoadingAnimation();
            	
            Swal.fire(
              "Sucesso!",
              "Candidatura submetida com sucesso!.",
              "success"
            );

            $('#concorrer').addClass("d-none");
            $('#candidatura-efectuada').removeClass("d-none");

          },
          error: (error) => {
            this.loading.hideLoadingAnimation();

            Swal.fire("Ops!", "Ocorreu um durante a candidatura!", "error");
          },
        });

        this.loading.hideLoadingAnimation();
      },
      error: (response) => {
        this.loading.hideLoadingAnimation();
      },
    });
  }

  showVacancyList(vagas) {
    let novoCandidato = $("#demostrar-interesse").data("candidato");

    let result = [];
    let index = 0;
    vagas.map((vaga) => {
      if (vagas[index].candidatos) {
        !vagas[index].candidatos.includes(novoCandidato)
          ? result.push(vaga)
          : "";
      } else {
        result.push(vaga);
      }

      index++;
    });

    const selectOptions = result.map(
      (vaga) => `<option value="${vaga.postID}">${vaga.posicao}</option>`
    );
    Swal.fire({
      title: "Selecionar a vaga",
      html: `
            <form id="vaga-form">
                <div class="form-group ">
                    <label for="">Vagas</label>
                    <select id="vaga_post_id" required>
                      ${selectOptions.join("")}
                    </select>
                </div>
    

            </form>
            `,
      showCancelButton: true,
      confirmButtonText: "Salvar",
      preConfirm: () => {
        const form = document.getElementById("vaga-form");
        if (!form.checkValidity()) {
          Swal.showValidationMessage("Preencha todos campos por favor!");
          return false;
        }

        let vaga_post_id = $("#vaga_post_id").val();
        let post_selected = vagas.filter((item) => item.postID == vaga_post_id);

        let candidatos = post_selected[0].candidatos;

        if (candidatos) {
          candidatos.push(novoCandidato);
        } else {
          candidatos = [novoCandidato];
        }

        let data = {
          acf: {
            candidatos,
          },
        };

        this.loading.showLoadingAnimation();
        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/vaga/" + vaga_post_id,
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: (response) => {
            this.loading.hideLoadingAnimation();
            	
            
            $.ajax({
              type: "POST",
              url: maisempregoData.root_url + "/wp-json/maisemprego/notificar/v1/empresa/interesse",
              data: {
                candidato_id: novoCandidato,
                vaga_id:  vaga_post_id
              },
              dataType: "json",
              beforeSend: (xhr) => {
                xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
              },
              success: (response) => {
                // console.log("Resposta envio de notificaco",response);
              },
              error: (error) => {
                Swal.fire("Error!", "Ocorreu um durante tente de novo!", "error");
              },
            });





            Swal.fire(
              "Salvo!",
              "Interesse demostrado com sucesso!.",
              "success"
            );
          },
          error: (error) => {
            this.loading.hideLoadingAnimation();
            Swal.fire("Error!", "Ocorreu um durante tente de novo!", "error");
          },
        });

        return false;
      },

      customClass: {
        content: "my-swal-content",
        popup: "my-swal-container",
        confirmButton: "confirm-swal-button",
        cancelButton: "cancel-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle form submission success
        const { descricao, posicao } = result.value;
      }
    });
  }


    
}

export default Vaga;
